<app-sidenav>
  <h2 class="page-title pt-2 pl-5 mt-4">MEU PERFIL</h2>
  <div class="row d-flex  p-5 d-grid gap-3">
    <div class="box-dividido">
      <div class="box-superior">
        <div class="row justify-content-center mb-3">
          <p class="info-plugins">
            <i placement="top" class="ml-3 fas fa-info-circle"></i>
            Para garantir que seus dados sejam salvos corretamente, desative as extensões ou plugins do seu navegador. <a (click)="openModalInfo()">Saiba mais.</a>
          </p>
        </div>
        <form [formGroup]="formUpdateUsuario">
          <h3 class="titulo">Dados do Solicitante</h3>
            <div class="form-group col-md-12 mt-3">
              <label class="form-label">CPF</label>
              <input type="text" mask="000.000.000-00" formControlName="documentoIdentificador" class="form-control custom-input">
            </div>
           <div class="form-group col-md-12 mt-3">
              <label class="form-label">Nome Completo</label>
              <input type="text" formControlName="nome" class="form-control custom-input">
            </div>
            <div class="form-group col-md-12 mt-3">
              <label class="form-label">Email</label>
              <input data-testid="altera-email-perfil" type="text" formControlName="email" autocomplete="off" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="email.invalid && (email.dirty || email.touched)">Digite um email válido.</span>
            </div>
            <div class="form-group col-md-12 mt-3 mb-1">
              <label class="form-label">Confirmar Email</label>
              <input data-testid="confirma-email-perfil" autocomplete="off" type="text" formControlName="confirmaEmail" class="form-control custom-input">
              <span class="error-form ml-2" *ngIf="confirmaEmail.invalid && (confirmaEmail.dirty || confirmaEmail.touched)">Digite um email válido.</span>
            </div>
            <span class="error-form ml-2" *ngIf="!emailVerified">Email não verificado.</span>
          <div class="form-row d-flex justify-content-center align-items-center">
            <button class="btn-atualizar btn-solicitante" (click)="updateUsuario()">Atualizar</button>
          </div>
        </form>
      </div>
      <div class="box-superior">
        <form [formGroup]="formUpdateSenha">
          <h3 class="titulo">Alterar senha</h3>
            <div class="form-group col-md-12 mt-3">
              <label class="form-label">Senha atual <b class="text-danger">*</b></label>
              <div class="password-container">
                <input name="senhaAntiga" formControlName="senhaAntiga" [type]="mostrarSenhaAtual ? 'text' : 'password'" class="form-control custom-input" placeholder="Digite sua senha atual">
                <i class="fas" [ngClass]="mostrarSenhaAtual ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarSenhaAtual = !mostrarSenhaAtual"></i>
              </div>
            </div>
            <div class="form-group col-md-12 mt-1">
              <label class="form-label">Nova senha <b class="text-danger">*</b></label>
              <div class="password-container">
                <input [type]="mostrarSenha ? 'text' : 'password'" class="form-control custom-input" formControlName="novaSenha" placeholder="Digite sua nova senha" (input)="checkSenha()">
                <i class="fas" [ngClass]="mostrarSenha ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarSenha = !mostrarSenha"></i>
              </div>
            </div>
            <div class="form-group col-md-12 mt-1">
              <label class="form-label">Confirme a nova senha <b class="text-danger">*</b></label>
              <div class="password-container">
                <input [type]="mostrarConfirmarSenha ? 'text' : 'password'" class="form-control custom-input" formControlName="confirmaSenha" placeholder="Digite novamente sua nova senha">
                <i class="fas" [ngClass]="mostrarConfirmarSenha ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarConfirmarSenha = !mostrarConfirmarSenha"></i>
              </div>
            </div>
            <div class="content col-md-12 mt-1 mb-5">
              <p>Sua senha deve conter:</p>
              <ul class="requirement-list col-md-12 mt-1">
                <li [ngClass]="{ 'text-success': checarSenha.minLength, 'text-danger': !checarSenha.minLength }">
                  <i class="fa" [ngClass]="checarSenha.minLength ? 'fa-check' : 'fa-times'"></i>
                  <span> No mínimo 8 caracteres</span>
                </li>
                <li [ngClass]="{ 'text-success': checarSenha.uppercase, 'text-danger': !checarSenha.uppercase }">
                  <i class="fa" [ngClass]="checarSenha.uppercase ? 'fa-check' : 'fa-times'"></i>
                  <span> 1 letra maiúscula</span>
                </li>
                <li [ngClass]="{ 'text-success': checarSenha.specialCharacter, 'text-danger': !checarSenha.specialCharacter }">
                  <i class="fa" [ngClass]="checarSenha.specialCharacter ? 'fa-check' : 'fa-times'"></i>
                  <span> 1 caractere especial (!,@,#,$)</span>
                </li>
                <li [ngClass]="{ 'text-success': checarSenha.number, 'text-danger': !checarSenha.number }">
                  <i class="fa" [ngClass]="checarSenha.number ? 'fa-check' : 'fa-times'"></i>
                  <span> 1 número</span>
                </li>
              </ul>
            </div>
            <div class="form-row d-flex justify-content-center align-items-center">
              <button class="btn-atualizar" (click)="updatePassword()">Atualizar</button>
            </div>
        </form>
      </div>
    </div>


      <div class="box-form col-lg-12 col-md-12 col-sm-12 mt-3 p-5" *ngFor="let emp of usuario.empresas; let i = index">
        <div class="form-row align-items-center">
            <h2 class="titulo-secundario">
              <span>Credor Pessoa Jurídica {{ i + 1 }}</span>
              <p data-testid="botao-edit-representante" class="icon-change" *ngIf="emp.necessaryAdjustment" (click)="updateEmpresa(emp)"><i class="far fa-edit"></i> Editar</p></h2>
        </div>

        <div class="form-row mt-2">
          <div class="col-md-6">
            <label class="form-label">
              CNPJ
            </label>
            <input type="text" [(ngModel)]="emp.cnpj" mask="AA.AAA.AAA/AAAA-AA" class="form-control custom-input" disabled>
          </div>
          <div class="col-md-6">
            <label class="form-label">
              Nome / Razão Social
            </label>
            <input type="text" [(ngModel)]="emp.nomeEmpresa" class="form-control custom-input" disabled>
          </div>
        </div>
      </div>
      <div class="form-row d-flex-justify-content-start mt-4">
        <button data-testid="botao-cadastra-credor" class="btn-add-empresa" (click)="cadastrarEmpresa()">Adicionar nova empresa <i class="fas fa-arrow-right"></i></button>
      </div>
  </div>
</app-sidenav>
